import { render, staticRenderFns } from "./AscIcon.vue?vue&type=template&id=882dac42&scoped=true&"
import script from "./AscIcon.vue?vue&type=script&lang=js&"
export * from "./AscIcon.vue?vue&type=script&lang=js&"
import style0 from "./AscIcon.vue?vue&type=style&index=0&id=882dac42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882dac42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
